<template>
	<teleport :to="teleportTarget" :disabled="disableTeleport">
		<transition appear name="slide-fade">
			<div v-if="show" style="display: block" class="modal" tabindex="-1" role="dialog" :style="`--bs-modal-zindex: ${modalZIndex}`">
				<div class="modal-dialog" role="document" v-bind="$attrs">
					<div class="modal-content">
						<div class="modal-header">
							<h5 class="modal-title"><slot name="title"/></h5>
							<button type="button" class="btn-close" aria-label="Close" @click="$emit('close')"></button>
						</div>
						<div class="modal-body"><slot name="body"/></div>
						<div class="modal-footer">
							<slot name="footer"><button type="button" class="btn btn-danger" @click="$emit('close')">Close</button></slot>
						</div>
					</div>
				</div>
			</div>
		</transition>
		<transition appear name="fade">
			<div v-if="show" class="modal-backdrop fade show" :style="`--bs-backdrop-zindex: ${backdropZIndex}`"/>
		</transition>
	</teleport>
</template>

<style scoped lang="scss">
	.fade-enter-active, .fade-leave-active {
		transition: opacity .15s linear;
	}
	.fade-leave-active {
		transition-delay: 150ms;
	}
	.fade-enter-from, .fade-leave-to {
		opacity: 0;
	}

	.slide-fade-enter-active, .slide-fade-leave-active {
		transition: opacity .15s linear, transform .3s ease-out;
	}
	.slide-fade-enter-from, .slide-fade-leave-to {
		transform: translate(0, -25%);
		opacity: 0;
	}
</style>

<script lang="ts">
import { defineComponent, PropType } from "vue";

const component = defineComponent({
	props: {
		show: { type: Boolean, required: true },
		teleportTarget: { type: String, default: "body" },
		disableTeleport: { type: Boolean, default: false },
		modalZIndex: { type: [Number, String, null] as PropType<number|string|null>, default: 1055 },
		backdropZIndex: { type: [Number, String, null] as PropType<number|string|null>, default: 1050 },
	},
	inheritAttrs: false,
	emits: [
		"close",
	],
});

export default component;
</script>
